// Ordering for fn_get_knowledge_gaps items.
//
// `incorrect_information` sorts above everything else regardless of how often it
// was asked: a gap is a question the site failed to answer, but incorrect
// information is the agent stating something false, and one of those outranks
// fifty missing answers. Everything else falls back to occurrences, descending.
//
// This is ORDERING, not computation — no value is derived, summed or changed,
// so it stays inside the render-only boundary. It lives here rather than as an
// inline comparator in JSX because two panels (voice and chat) sort the same
// list and the rule is worth a test of its own.

const INCORRECT = 'incorrect_information';

const occurrences = (item) => Number(item?.occurrences ?? 0);

/**
 * Rank knowledge-gap items for display.
 *
 * @param {Array<{gap_type?: string, occurrences?: number}>} items
 * @returns {Array} a NEW array — the input is never mutated, because callers
 *   hold RPC payloads that other panels read.
 */
export const sortKnowledgeGaps = (items) => {
  if (!Array.isArray(items)) return [];
  return [...items].sort((a, b) => {
    const aIncorrect = a?.gap_type === INCORRECT;
    const bIncorrect = b?.gap_type === INCORRECT;
    if (aIncorrect !== bIncorrect) return aIncorrect ? -1 : 1;
    return occurrences(b) - occurrences(a);
  });
};

export default sortKnowledgeGaps;
